import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { IDrainPipe } from '../../shared/iProject';
import { EReduxState } from '../enum';
import { IReduxState } from '../interface';

const initialState: IReduxState<IDrainPipe[]> = {
    status: EReduxState.initialState,
};

export const drainPipeSlice = createSlice({
    name: 'drainPipe',
    initialState,
    reducers: {
        cleanSoil: state => {
            state.status = EReduxState.initialState;
            state.data = undefined;
        },
        setDrainPipe: (state, action: PayloadAction<IDrainPipe[]>) => {
            state.status = EReduxState.fulfilled;
            state.data = action.payload;
        },
    },
});

export const { cleanSoil, setDrainPipe } = drainPipeSlice.actions;

export const selectDrainPipe = (state: RootState) => state.drainPipe;

export default drainPipeSlice.reducer;
